import { localizedAuthRedirect } from '@/utils/authRedirects'

export default function ({ $auth, app }) {
  $auth.onRedirect(to => localizedAuthRedirect(to, app.localePath))
}
